var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmexNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.143066,
    y: 0.00119019,
    width: 35,
    height: 23.3363,
    rx: 4,
    fill: "#006FCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1561 4.22633H32.2591L30.7449 8.72372L29.1647 4.22633H26.2019V11.2291L23.1732 4.22633H20.7373L17.7086 11.3811H19.8154L20.408 9.95024H23.5683L24.1609 11.3811H28.1113V6.40677L29.8889 11.3811H31.5349L33.3125 6.40677V11.3811H35.1561V12.4713H32.72L30.7449 14.72L28.7038 12.4713H20.3422V19.6261H28.6381L30.6789 17.3094L32.72 19.6261H35.1561V20.5118H32.2591L30.6789 18.7403L29.0987 20.5118H19.2888V12.335H16.1284L20.0788 3.13591H23.8975L25.28 6.27047V3.13591H30.0206L30.8106 5.52091L31.6008 3.13591H35.1561V4.22633ZM35.1561 14.0385L33.3785 16.0146L35.1561 17.9907V19.6261L31.93 16.0146L35.1561 12.4713V14.0385ZM26.2019 19.6261V17.9226H22.2516V16.8324H26.136V15.197H22.2516V14.1068H26.2019V12.4713L29.4938 16.0146L26.2019 19.6261ZM21.0005 8.38286L21.9224 6.06611L22.8441 8.38286H21.0005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexNew);
export default __webpack_public_path__ + "static/media/AmexNew.a572c8c0625f6e3409e1a138e2f4dd9f.svg";
export { ForwardRef as ReactComponent };